export { HighlightPipe } from './highlight.pipe';
